import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Globals } from '@app/service/globals.service';
import { RecruitService } from '@home/service/recruit.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-recruit-view1',
  templateUrl: './recruit-view1.component.html',
  styleUrls: ['./recruit-view1.component.scss']
})

export class RecruitView1Component implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  @Input() memberInfo: any;

  params: any = {
    tab: '',      // 구인, 구직 : offer, search
    type: '',     // 리스트, 내용보기, 쓰기, 수정 : list, view, write, modify
    boardSeq: 0,  // 게시판 순번
    no: 1,        // 현재 페이지
    row: 10,      // 페이지당 보여줄 갯수
  };

  public board: any = [];
  public modifyAuth = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,

    private recruitService: RecruitService,
    private globals: Globals,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if ( params.type === 'list' ) {
        return false;
      }

      this.params.tab = ( typeof params.tab === 'undefined' || params.tab == '' ) ? 'offer' : params.tab;
      this.params.type = ( typeof params.type === 'undefined' || params.type == '' ) ? 'list' : params.type;
      this.params.no = ( typeof params.no === 'undefined' || params.no == '' ) ? '1' : params.no;
      this.params.boardSeq = ( typeof params.boardSeq === 'undefined' || params.boardSeq == '' ) ? '0' : params.boardSeq;

      if ( this.params.type === 'view' && this.params.boardSeq == '' ) {
        this.toastrService.error( '게시물이 존재하지 않습니다.', '게시판' );

        this.params.type = 'list';

        this.router.navigate(
        [location.pathname],
        {
          relativeTo: this.activatedRoute,
          queryParams: this.params,
          queryParamsHandling: '', // remove to replace all query params by provided
        });

        return false;
      }

      // indicator 표시 숨김
      setTimeout (() => {
        this.globals.indicator.next(true);

        this.getBoardJobOfferDetail();
      });
    });
  }

  /*******************************************************************************
    설  명 : 구인 게시판 상세정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardJobOfferDetail() {
    this.recruitService.getBoardJobOfferDetail(this.params).then(response => {
      if ( response.ResultCode ) {
        this.board = response.data;
      } else {
        this.board = [];
      }
      this.globals.indicator.next(false);
    }, error => {
      this.globals.indicator.next(false);

      this.toastrService.error('구인 정보를 가져오는데 실패하였습니다.', '구인 정보');
    });
  }

  /*******************************************************************************
    설  명 : 수정/삭제 권한 확인
    입력값 : 없음
    리턴값 : boolean
  *******************************************************************************/
  authEditCheck( writer ) {
    const isAuth = (this.memberInfo.level >= 80 || this.memberInfo.memNo === writer) ? true : false;
    if (isAuth) {
      return true;
    }
    return false;
  }

  /*******************************************************************************
    설  명 : 구인 정보 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  modify() {
    this.params.type = 'modify';
    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 구인 정보 삭제
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setBoardJobOfferDelete() {
    setTimeout (() => {
        this.globals.indicator.next(true);
    });

    this.recruitService.setBoardJobOfferDelete(this.params).then(response => {
      if ( response.ResultCode ) {
        this.params.type = 'list';
        this.params.boardSeq = '0';
        this.linkRouter();
      }
      this.globals.indicator.next(false);
    }, error => {
      this.globals.indicator.next(false);

      this.toastrService.error('구인 정보 삭제를 실패하였습니다.', '구인 정보 삭제');
    });
  }

  /*******************************************************************************
    설  명 : 목록으로
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  list() {
    this.params.type = 'list';
    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 라우터 변경
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  linkRouter() {
    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
    });
  }
}

